import { UserAPIModelsERoles } from 'user-ts-ng-client';

import { User } from '@features/organization/models/user.model';

export const USERS_MOCK: User[] = [
  {
    id: '1',
    organizationId: '1',
    name: 'John Doe',
    email: 'test@mail.com',
    phone: '123-456-7890',
    role: UserAPIModelsERoles.OrganizationAdmin,
    lastAccess: '2023-10-01T12:00:00Z',
    creationDate: '2023-01-15T09:30:00Z',
  },
  {
    id: '2',
    organizationId: '1',
    name: 'John Doe',
    email: 'test@mail.com',
    phone: '123-456-7890',
    role: UserAPIModelsERoles.OrganizationAdmin,
    lastAccess: '2023-10-01T12:00:00Z',
    creationDate: '2023-01-15T09:30:00Z',
  },
  {
    id: '3',
    organizationId: '1',
    name: 'John Doe',
    email: 'test@mail.com',
    phone: '123-456-7890',
    role: UserAPIModelsERoles.OrganizationAdmin,
    lastAccess: '2023-10-01T12:00:00Z',
    creationDate: '2023-01-15T09:30:00Z',
  },
  {
    id: '4',
    organizationId: '1',
    name: 'Jane Smith',
    email: 'test@mail.com',
    phone: '123-456-7890',
    role: UserAPIModelsERoles.OrganizationContributor,
    lastAccess: '2023-10-02T14:30:00Z',
    creationDate: '2023-02-20T11:15:00Z',
  },
  {
    id: '5',
    organizationId: '1',
    name: 'Alice Johnson',
    email: 'test@mail.com',
    phone: '123-456-7890',
    role: UserAPIModelsERoles.OrganizationContributor,
    lastAccess: '2023-10-03T08:45:00Z',
    creationDate: '2023-03-05T10:00:00Z',
  },
];
